export default __webpack_public_path__ + "static/media/InPerson.5dd0d302.svg";